import { render, staticRenderFns } from "./select-products.vue?vue&type=template&id=63d0cb1d&lang=pug&"
import script from "./select-products.vue?vue&type=script&lang=js&"
export * from "./select-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports